/* eslint-disable react/prop-types */
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import { BsCircleFill } from "react-icons/bs";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  dialogContent: {
    padding: "25px 35x 25px 20px",
    flexDirection: "column",
    alignItems: "flex-start",
    display: "flex",
    color: "black",
  },
  dialogActions: {
    paddingBottom: "12px",
    paddingRight: "6%",
    paddingTop: "12px",
    backgroundColor: "#F6F6F6",
  },
  dialogRoot: {
    maxWidth: "550px",
    overflow: "hidden",
  },
  dialogRootSmall: {
    maxWidth: "550px",
    overflow: "hidden",
  },
  textContainer: {
    padding: "10px 20px 10px 10px",
  },
  textContainerFirst: {
    padding: "20px 20px 10px 10px",
  },
  textContainerWithIcon: {
    padding: "0px 20px 0px 10px",
  },
  dialogText: {
    marginTop: "15px",
    marginBottom: "15px",
    paddingLeft: "25px",
  },
  closeButton: {
    backgroundColor: theme.palette.primary.main,
  },
  textBold: {
    fontWeight: "bold",
    fontSize: "15px",
  },
  icon: {
    color: "#474747",
    marginRight: "5px",
  },
  textCointainerGroup: {
    marginLeft: "8px",
    paddingBottom: "30px",
  },
}));

const StyledDialogTitle = withStyles(() => ({
  root: {
    padding: "0px",
  },
}))(DialogTitle);

const ConsentDialogComponent = ({
  open = false,
  handleClose,
  isSmallScreen = false,
}) => {
  const classes = useStyles();

  const handleCloseButton = () => {
    handleClose();
  };

  const StyledButton = withStyles(() => ({
    label: {
      padding: "2px 10px 2px 10px",
    },
  }))(Button);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
      disableRestoreFocus
      classes={{
        paperWidthMd: isSmallScreen
          ? classes.dialogRootSmall
          : classes.dialogRoot,
      }}
    >
      <StyledDialogTitle className={classes.dialogTitle}>
        <div className={classes.dialogText}>User tracking consent</div>
      </StyledDialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.textContainerFirst}>
          We may automatically log information about your use of Athena tracking
          user, your computer or mobile device, and your activity over time on
          our Service, such as:
        </div>
        <div div className={classes.textContainer}>
          <span className={classes.textBold}>Online activity data,</span>{" "}
          including how long you spent on a page or screen, navigation paths
          between pages or screens, information about your activity on a page or
          screen, and access times.
        </div>
        <div div className={classes.textContainer}>
          <span className={classes.textBold}>Device data,</span> such as your
          computer or mobile device operating system and version number, and
          general location information such as city or geographic area.
        </div>
        <div className={classes.textContainer}> We may use these data: </div>
        <div className={classes.textCointainerGroup}>
          <div className={classes.textContainerWithIcon}>
            <BsCircleFill className={classes.icon} size="5" />
            To provide, operate, and improve the Services and our business
          </div>
          <div className={classes.textContainerWithIcon}>
            <BsCircleFill className={classes.icon} size="5" />
            To respond to your inquiries or support tickets
          </div>
          <div className={classes.textContainerWithIcon}>
            <BsCircleFill className={classes.icon} size="5" />
            To operate, personalize, and improve the Services, including for
            analytics purposes
          </div>
          <div className={classes.textContainerWithIcon}>
            <BsCircleFill className={classes.icon} size="5" />
            For research and development purposes, including to improve the
            Services, understand and analyze the usage trends and preferences of
            our users, and develop new features, functionality, and services.{" "}
          </div>
        </div>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <StyledButton
          autoFocus
          variant="contained"
          color="primary"
          disableRipple
          style={{ textTransform: "none" }}
          onClick={() => handleCloseButton()}
        >
          Accept
        </StyledButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConsentDialogComponent;
